// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__oijnm","wrapper_full":"loader_wrapper_full__ow0J0","loader":"loader_loader__NcIvu","load":"loader_load__8EYdc"};